<template>
  <div   class="d-flex justify-content-between" v-if="allItems.length">
    <div class="text-right m-4">
      <h5 style="font-size: 1vw !important"> </h5>
    </div>
    <div class="d-flex" v-if="allItems.length">
      <a :href="`${this.download_url}/Definition_of_basic_measures/all/word/by/id/${id_route}`" style="margin-top: 1.3vw;"
         class="btn btn-primary btn-submit-1">خروجی Word</a>
      <a :href="`${this.download_url}/Definition_of_basic_measures/all/pdf/by/id/${id_route}`"
         style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
        PDF</a>

      <a    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; " class="btn btn-primary btn-submit-1 "
            :style="!status_show ? 'background-color: red; border-color: red' : 'background-color: green; border-color: green'"
            @click="acceptComplete"
      >
        <div v-if="!status_loading">

          <span v-if="!status_show">  تایید وضعیت</span>
          <span v-else>عدم تایید</span>
        </div>
        <div v-else>
          <div class="loader-line"></div>

        </div>
      </a>
    </div>

  </div>
  <div class="table-responsive p-5"  style=" ">
    <center v-show="!allItems.length">
      اطلاعاتی یافت نشد
    </center>
    <table class="table table-striped" v-show="allItems.length" style="">
      <tbody>
      <tr>
        <th><strong>ردیف</strong></th>
        <th style="width: 15vw;"><strong>
          مسئله
        </strong></th>

        <th><strong>نماگر وضعیت
          بهره‌وری مرتبط با مسئله
        </strong></th>
        <th><strong> سیاست مداخله </strong></th>
        <th><strong> اقدام پیشران بهره‌وری </strong></th>


      </tr>

      <tr class="bg-white" v-for="(item, index) in allItems">
        <td>{{ index + 1 }}</td>
        <td>
          {{ item.title }}
        </td>
        <td>
          {{item.title_photographer}}

        </td>
        <td>
          {{item.basic_measures_problem && item.basic_measures_problem.intervention_policy}}
        </td>
        <td>
          <div class="d-flex align-items-center justify-content-center">
            <button @click.prevent="CompletePropulsionModal(item.id)" class="btn btn-submit-1 btn-primary">مشاهده</button>
          </div>
        </td>




      </tr>


      </tbody>
    </table>
  </div>
  <center  v-show="allItems.length">
  </center>



  <div v-show="MissionModal" dir="rtl" class="modal__error slide-top"
       style="z-index: 2147483647; top: 35%; width: 80vw;">
    <div><p> ماموریت </p>
      <p @click.prevent="MissionModal=!MissionModal">❌</p></div>
    <hr>
    <div class="d-flex">
      <div class="d-flex flex-column">
        <label>عنوان ماموریت </label>
        <input v-model="title" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column mx-2">
        <label>خدمت متناظر</label>
        <input v-model="service" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column mx-2">
        <label>شروع اقدام</label>
        <Vue3PersianDatetimePicker v-model="start_date"></Vue3PersianDatetimePicker>
      </div>
      <div class="d-flex flex-column">
        <label>پایان اقدام</label>
        <Vue3PersianDatetimePicker v-model="end_date"></Vue3PersianDatetimePicker>

      </div>
      <div class="d-flex flex-column mx-2">
        <label>سنجه تحقق اقدام</label>
        <input v-model="gauge" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column">
        <label>هدف کمی‌/‌کیفی </label>
        <input v-model="target" type="text" class="form-control">
      </div>
      <button @click.prevent="store_oneModal" class="btn btn-submit-1 btn-primary my-4" style="font-size: 2vw; width: 3vw; margin-right: 1vw;"><span
          style="transform: translateY(0.2vw)">+</span></button>

    </div>
    <br>
    <center v-show="!allItemsOneModal.length">
      اطلاعاتی یافت نشد
    </center>
    <table v-show="allItemsOneModal.length" class="table table-striped">
      <tbody>
      <tr>
        <th><strong> عنوان ماموریت </strong></th>

        <th><strong> خدمت متناظر</strong></th>

        <th style="width: 8vw;"><strong> فعالیت‌های کلیدی </strong></th>
      </tr>
      <tr v-for="item in allItemsOneModal">
        <td>{{item.title}}</td>
        <td>{{item.service}}</td>
        <td>{{item.start_date}}</td>
        <td>{{item.end_date}}</td>
        <td>{{item.gauge}}</td>
        <td>{{item.target}}</td>

        <td>
          <button @click.prevent="CompleteKeyDefinitions(1)" class="btn btn-submit-1 btn-primary">مشاهده</button>
        </td>
      </tr>
      </tbody>
    </table>

  </div>

  <div v-show="PropulsionModal" dir="rtl" class="modal__error slide-top"
       style="z-index: 2147483647; top: 35%; width: 70vw;">
    <div><p>  اقدام پیشران   </p>
      <p @click="PropulsionModal=!PropulsionModal">❌</p></div>
    <hr>

    <div class="d-flex">



    </div>
    <br>
    <center v-show="!allItemsTreeModal.length">
      اطلاعاتی یافت نشد
    </center>
    <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

    <table class="table table-striped" v-show="allItemsTreeModal.length">
      <tbody>
      <tr>
        <th><strong> اقدام   پیشران    </strong></th>
        <th><strong> زمان شروع اقدام </strong></th>
        <th><strong> زمان پایان اقدام </strong></th>
        <th><strong> سنجه تحقق اقدام  </strong></th>
        <th><strong> هدف کمی/کیفی    </strong></th>
        <th><strong>فعالیت کلیدی</strong></th>

      </tr>
      </tbody>
      <tr class="bg-white" v-for="item in allItemsTreeModal">
        <td>{{item.title}}</td>
        <td>{{item.date_start}}</td>
        <td>{{item.date_end}}</td>
        <td>{{item.realization}}</td>
        <td>{{item.target}}</td>
        <td>
          <div class="d-flex align-items-center justify-content-center">
            <button @click.prevent="CompleteKeyDefinitions(item.id)" class="btn btn-submit-1 btn-primary">مشاهده</button>
          </div>
        </td>


      </tr>
    </table>
  </div>

  <div v-show="KeyDefinitionsModal" dir="rtl" class="modal__error slide-top"
       style="z-index: 2147483647; top: 35%; width: 70vw;">
    <div class="d-flex justify-content-between w-100"><p> فعالیت‌های کلیدی </p>
      <p @click="KeyDefinitionsModal=!KeyDefinitionsModal">❌</p></div>
    <hr>


    <br>
    <center v-show="!allItemsTwoModal.length">
      اطلاعاتی یافت نشد
    </center>

    <table class="table table-striped" v-show="allItemsTwoModal.length">
      <tbody>
      <tr>
        <th><strong> عنوان فعالیت </strong></th>
        <th><strong> دستگاه متولی </strong></th>
        <th><strong> دستگاه همکار </strong></th>
        <th><strong> زمان شروع فعالیت </strong></th>
        <th><strong> زمان پایان فعالیت </strong></th>
        <th><strong> پیشرفت مورد انتظار فعالیت در پایان سال (%) </strong></th>
      </tr>
      </tbody>
      <tr class="bg-white" v-for="item in allItemsTwoModal">
        <td>{{item.title}}</td>
        <td>{{item.trustee_device}}</td>
        <td>{{item.partner_device}}</td>
        <td>{{item.start_date}}</td>
        <td>{{item.end_date}}</td>
        <td>{{item.expected_progress}}</td>


      </tr>
    </table>
  </div>
  </div>
</template>
<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
  components: {Vue3PersianDatetimePicker},
  data() {
    return {
      PropulsionModal: false,
      MissionModal: false,
      KeyDefinitionsModal: false,
      allItems: [],
      id: '',
      id_two: '',
      // stage 1
      allItemsOneModal: [],
      title: '',
      service: '',
      start_date: '',
      end_date: '',
      gauge: '',
      target: '',
      //stage 2
      allItemsTwoModal: [],
      allItemsTreeModal: [],
      title_task: '',
      trustee_device: '',
      partner_device: '',
      start_date_task: '',
      end_date_task: '',
      expected_progress: '',
      id_route: this.$route['params']['id'],
      id_user: '',
      title_PropulsionBasicAction: '',
      start_date_PropulsionBasicAction: '',
      end_date_PropulsionBasicAction: '',
      realization_PropulsionBasicAction: '',
      target_PropulsionBasicAction: '',
      status_show: false,
      status_loading: false,
    }
  },
  methods: {
    acceptComplete(){
      if (this.status_loading){
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }

          })
          .catch();
    },
    resetData(){
      this.title_PropulsionBasicAction = ''
      this.start_date_PropulsionBasicAction = ''
      this.end_date_PropulsionBasicAction = ''
      this.realization_PropulsionBasicAction = ''
      this.target_PropulsionBasicAction = ''
    },
    all_TreeModal(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/PropulsionBasicAction_all/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsTreeModal.length=0
            response.all.forEach((ele)=>{
              this.allItemsTreeModal.push(ele)
            })



          })
          .catch();
    },
    store_PropulsionBasicAction_store(){
      if (!this.title_PropulsionBasicAction.length){
        toast.error('اقدام پیشران اجباری است')
        return;
      }
      if (!this.start_date_PropulsionBasicAction.length){
        toast.error('تاریخ شروع   اجباری است')
        return;
      }
      if (!this.end_date_PropulsionBasicAction.length){
        toast.error('تاریخ پایان   اجباری است')
        return;
      }
      if (!this.realization_PropulsionBasicAction.length){
        toast.error('سنجه تحقق اقدام اجباری است')
        return;
      }
      if (!this.target_PropulsionBasicAction.length){
        toast.error('هدف کمی/کیفی اجباری است')
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('problem_identifications_id', this.id_two)
      formdata.append('title', this.title_PropulsionBasicAction)
      formdata.append('date_start', this.start_date_PropulsionBasicAction)
      formdata.append('date_end', this.end_date_PropulsionBasicAction)
      formdata.append('realization', this.realization_PropulsionBasicAction)
      formdata.append('target', this.target_PropulsionBasicAction)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/PropulsionBasicAction_store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)

            this.all_TreeModal(this.id_two)
            this.resetData()
            // this.all_TreeModal()

          })
          .catch();
    },
    store_twoModal(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('problem_identification_id', this.id_two)
      formdata.append('propulsion_basic_actions_id', this.id_tree)
      formdata.append('title', this.title_task)
      formdata.append('trustee_device', this.trustee_device)
      formdata.append('partner_device', this.partner_device)
      formdata.append('start_date', this.start_date_task)
      formdata.append('end_date', this.end_date_task)
      formdata.append('expected_progress', this.expected_progress)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.title_task = ''
            this.trustee_device = ''
            this.partner_device = ''
            this.start_date_task = ''
            this.end_date_task = ''
            this.expected_progress = ''
            this.all_twoModal()

          })
          .catch();
    },
    store_oneModal(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('problem_identifications_id', this.id)
      formdata.append('title', this.title)
      formdata.append('service', this.service)
      formdata.append('start_date', this.start_date)
      formdata.append('end_date', this.end_date)
      formdata.append('gauge', this.gauge)
      formdata.append('target', this.target)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/mission_problems/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.title = ''
            this.service = ''
            this.start_date = ''
            this.end_date = ''
            this.gauge = ''
            this.target = ''
            this.all_oneModal()

          })
          .catch();
    },
    all_oneModal(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/mission_problems/all/${this.id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsOneModal.length=0
            response.all.forEach((ele)=>{
              this.allItemsOneModal.push(ele)
            })



          })
          .catch();
    },
    all_twoModal(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/all/${this.id_tree}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsTwoModal.length=0
            response.all.forEach((ele)=>{
              this.allItemsTwoModal.push(ele)
            })



          })
          .catch();
    },

    CompleteMission(id) {
      this.id = id
      this.all_oneModal()
      this.MissionModal = true

    },
    CompleteKeyDefinitions(id) {

      this.id_tree = id
      this.all_twoModal()
      this.KeyDefinitionsModal = true

    },
    CompletePropulsionModal(id) {
      this.id_two = id
      this.PropulsionModal = true
      this.all_TreeModal(id)

    },
    all() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {

              this.allItems.push(item)

            })
          })
          .catch();
    },
    store() {
      let obj = []
      this.allItems.forEach((item) => {
        const title_two = document.getElementById(`title_two_${item.id}`).value

        let record = {
          'problem_identifications_id': item.id,
          'intervention_policy': title_two,

          'id': item.basic_measures_problem ? item.basic_measures_problem.id : null
        }
        obj.push(record)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/BasicMeasuresProblem/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)

          })
          .catch();
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
  },
  mounted() {
    this.all()
  }
}
</script>
<style scoped>

</style>